import Axios from 'axios';
import {MessageBox} from "element-ui";
import router from "../router";
import base from "./common";
import qs from "qs";

let axios = Axios.create({
  baseURL: process.env.VUE_APP_BASE_PATH,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
});

axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  let url = config.url;
  // console.log(url,/(uthorize\/)+/g.test(url))
  // if (isPass(url)) {
  if (!/(authorize\/)+|(authorize)+|(logout)+|(\/admin\/)+/.test(url)) {
    return config;
  }
  if (localStorage.access_token) {
    config.headers["Authorization"] = "bearer " + localStorage.access_token
  }
  return config
}, (error) => {
  return Promise.reject(error)
});

let api_pass_401 = [
  /(researches\/authorize\/details)+/ // 每日研究详情
  , /(article\/sciences\/authorize\/\w+\/liked)+/ // 公益科普详情

];
let fail_401_count_ = 0;
axios.interceptors.response.use((response) => {
  return response;
}, (error => {
  if (error.response) {
    if (error.config.url.endsWith('/login')) {
      return error.response;
    } else if (error.response.status == 401) {
      for (let i = 0; i < api_pass_401.length; i++) {
        if (api_pass_401[i].test(error.config.url)) {
          throw error;
        }
      }
    }
    if (error.response.status == 401) {
      let refresh_token = localStorage.getItem("refresh_token");
      if (!refresh_token) {
        return
      }
      //1.尝试重新获取accessToken
      let params = {
        grant_type: 'refresh_token',
        scope: 'all',
        client_id: 'web',
        client_secret: 'secret',
        refresh_token: refresh_token,
      };
      if (fail_401_count_ > 1) {
        return;
      }
      axios.post(base.api.login, qs.stringify(params)).then(rest => {
        if (rest.data.access_token) {
          localStorage.clear();
          localStorage.setItem("refresh_token", rest.data.refresh_token);
          localStorage.setItem("access_token", rest.data.access_token);
          localStorage.setItem("expires_in", rest.data.expires_in);
          localStorage.setItem("get_token_date", new Date().getTime());
          // 刷新页面
          fail_401_count_ = 0;
          location.reload();
          return;
        } else {
          throw error;
        }
      }).catch(err => {
        //2.获取失败
        localStorage.clear();
        if (fail_401_count_ > 1) {
          return;
        }
        fail_401_count_++;
        MessageBox.alert('请重新登录', '', {
          confirmButtonText: '确定',
          callback: action => {
            fail_401_count_ = 0;
            router.push('/login')
          }
        });
      });
    }
  }
  return error.response;
}));

export const postAxios = (url, data) => {
  return axios.post(url, data);
};

export const putAxios = (url, data) => {
  return axios.put(url, data);
};

export const getAxios = (url, data) => {
  return axios.get(url, {
    params: data
  });
};
